
import { Link } from 'react-router-dom';

const clientProfiles = [
  {
    image: 'https://public.readdy.ai/ai/img_res/9302355a8c0cfbb233f970cf49b3d5f0.jpg',
    name: 'Dr. Richard Harmon',
    title: 'Cardiologist, UT Southwestern',
    quote: 'They found my family a plan that covers all our specialists at Baylor and UT Southwestern. The concierge service is exactly what busy physicians need.',
    neighborhood: 'Highland Park'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=elegant%20wealthy%20couple%20in%20their%2040s%20dressed%20in%20sophisticated%20business%20casual%20attire%2C%20warm%20confident%20smiles%2C%20luxury%20home%20interior%20background%2C%20affluent%20professional%20portrait%2C%20soft%20warm%20lighting&width=400&height=500&seq=trust-couple-exec-2&orientation=portrait',
    name: 'The Whitfield Family',
    title: 'Private Equity Executive',
    quote: 'After relocating to Preston Hollow, we needed an agency that understood premium coverage. They delivered beyond expectations — comprehensive plans for our entire family.',
    neighborhood: 'Preston Hollow'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=professional%20female%20dermatologist%20doctor%20in%20white%20coat%2C%20warm%20approachable%20smile%2C%20modern%20medical%20office%20background%2C%20confident%20successful%20woman%20physician%20portrait%2C%20clean%20bright%20lighting&width=400&height=500&seq=trust-doctor-derm-3&orientation=portrait',
    name: 'Dr. Priya Mehta',
    title: 'Dermatologist, Private Practice',
    quote: 'As a practice owner, I needed both personal and group coverage. They handled everything seamlessly and saved my practice over twelve thousand dollars annually.',
    neighborhood: 'University Park'
  },
];

export default function TrustSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-widest text-secondary uppercase mb-4">Trusted Across Park Cities</span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            Why Dallas&apos;s <strong>Top Physicians & Families</strong> Choose Us
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From Highland Park surgeons to Preston Hollow executives, our clients trust us with their most important asset — their family&apos;s health.
          </p>
        </div>

        {/* Client Profiles */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {clientProfiles.map((client, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={client.image}
                  alt={`${client.name} - ${client.title} - private health insurance client in ${client.neighborhood} Dallas`}
                  title={`${client.neighborhood} health insurance client`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-map-pin-2-line text-secondary text-sm"></i>
                  <span className="text-xs font-semibold text-secondary uppercase tracking-wide">{client.neighborhood}</span>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed italic mb-5">&ldquo;{client.quote}&rdquo;</p>
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                </div>
                <h3 className="text-lg font-bold text-primary">{client.name}</h3>
                <p className="text-sm text-gray-500">{client.title}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Neighborhoods Served Banner */}
        <div className="bg-primary rounded-2xl p-10 md:p-14 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-1/2 h-full opacity-10">
            <div className="w-full h-full bg-gradient-to-l from-secondary to-transparent"></div>
          </div>
          <div className="relative z-10 grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h3 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4">
                Proudly Serving Dallas&apos;s Most Prestigious Neighborhoods
              </h3>
              <p className="text-gray-300 text-base leading-relaxed mb-6">
                Our clients include physicians at UT Southwestern and Baylor Scott &amp; White, executives in the energy and finance sectors, and families across Dallas&apos;s most sought-after communities.
              </p>
              <Link
                to="/contact"
                className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-secondary hover:bg-secondary/90 text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer"
              >
                Request a Private Consultation
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { name: 'Highland Park', icon: 'ri-home-heart-line', desc: 'Premium family coverage' },
                { name: 'University Park', icon: 'ri-graduation-cap-line', desc: 'Physician & faculty plans' },
                { name: 'Preston Hollow', icon: 'ri-vip-crown-line', desc: 'Executive health plans' },
                { name: 'Park Cities', icon: 'ri-community-line', desc: 'Group & individual plans' },
              ].map((area, i) => (
                <div key={i} className="bg-white/10 backdrop-blur-sm rounded-lg p-5 border border-white/10 hover:bg-white/15 transition-all cursor-default">
                  <div className="w-10 h-10 flex items-center justify-center bg-secondary/20 rounded-lg mb-3">
                    <i className={`${area.icon} text-xl text-secondary`}></i>
                  </div>
                  <h4 className="text-white font-semibold text-sm mb-1">{area.name}</h4>
                  <p className="text-gray-400 text-xs">{area.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
